export type ViewSwitcherModes = 'columns' | 'list';

export const viewModes: Record<ViewSwitcherModes, ViewSwitcherModes> = {
  columns: 'columns',
  list: 'list',
};
